<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form [formGroup]="formGroup" class="fpx-form-group">
        <section class="account-sec">
          <h3 class="fpx-sec-title">{{'REPAYMENTSCHEDULE.loanAccount'| translate}} </h3>
          <app-loan-list
            formControlName="loanInfo"
            (emitLoanDetails)="onChangeLoanList($event)"
          ></app-loan-list>
        </section>

        <section class="request-details-sec">
          <!-- <h3 class="fpx-sec-title">Repayment details</h3> -->
          <div class="details-entry-panel">
            <div *ngIf="showCalender" class="show-calender">
              <h4 class="calender--title">{{'REPAYMENTSCHEDULE.subTitle'| translate}}</h4>
              <div class="calender--input__container">
                <input
                  class="input-field"
                  type="text"
                  id="datePicker"
                  readonly
                />
                <i class="calender--input__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="17.145"
                    viewBox="0 0 19 17.145"
                  >
                    <g
                      id="_001-calendar"
                      data-name="001-calendar"
                      transform="translate(0 -25)"
                    >
                      <path
                        id="Path_9879"
                        data-name="Path 9879"
                        d="M19,30.344V28.154a1.672,1.672,0,0,0-1.67-1.67h-.223v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H11.17v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H5.232v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H1.67A1.672,1.672,0,0,0,0,28.154v2.189Z"
                        fill="#004A63"
                      />

                      <path
                        id="Path_9880"
                        data-name="Path 9880"
                        d="M0,199v9.018a1.672,1.672,0,0,0,1.67,1.67H17.33a1.672,1.672,0,0,0,1.67-1.67V199Zm5.344,7.719H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm0-2.375H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm0-2.375H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm4.75,4.75H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm4.75,4.75H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Z"
                        transform="translate(0 -167.543)"
                        fill="#004A63"
                      />
                    </g>
                  </svg>
                </i>
              </div>
              <div class="d-flex justify-between">
                <button class="btn-calendar">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8.325"
                      height="12.744"
                      viewBox="0 0 8.325 12.744"
                    >
                      <path
                        id="Shape"
                        d="M3.5,0,0,3.544,3.5,7.088"
                        transform="translate(2 2.828)"
                        fill="none"
                        stroke="#000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="4"
                        opacity="0.1"
                      />
                    </svg>
                  </i>
                </button>
                <span class="text-month"
                  >{{ displayMonth }}&nbsp; {{ displayYear }}</span
                >
                <button class="btn-calendar">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8.325"
                      height="12.745"
                      viewBox="0 0 8.325 12.745"
                    >
                      <path
                        id="Shape"
                        d="M0,0,3.5,3.544,0,7.088"
                        transform="translate(2.828 2.828)"
                        fill="none"
                        stroke="#004A63"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="4"
                      />
                    </svg>
                  </i>
                </button>
              </div>
              <div class="d-flex calendar-table" *ngIf="calendar">
                <div>{{'REPAYMENTSCHEDULE.mon'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.tue'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.wed'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.thu'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.fri'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.sat'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.sun'| translate}}</div>
              </div>
              <ng-container
                *ngFor="let row of calendar | chunk: 7; let i = index"
              >
                <div class="d-flex calendar-table">
                  <div
                    class="calendar-day"
                    [ngClass]="{
                      'past-date': currenctMonth != c.date.getMonth(),
                      today: c.isToday
                    }"
                    *ngFor="let c of row; let j = index"
                  >
                    <div
                      class="calendar-day-header"
                      [ngClass]="{
                        'select-date': installmentDates.includes(c.utcDate)
                      }"
                    >
                      <span>{{ c.date.getDate() }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="list--repayment">
              <p class="list--title">
                {{'REPAYMENTSCHEDULE.subHeading'| translate}}
              </p>
              <div class="d-flex table--repayment">
                <div>{{'REPAYMENTSCHEDULE.dueDate'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.instalment'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.principal'| translate}}</div>
                <div>{{'REPAYMENTSCHEDULE.interest'| translate}}</div>
              </div>
              <ng-container *ngFor="let list of repaymentScheduleDetails">
                <div class="d-flex table--repayment repayment-record">
                  <div>{{ list.dueDate | dateFormatter: 'yyyy-mm-dd' }}</div>
                  <div>{{ formatAmount(list.installmentAmount) }}</div>
                  <div>{{ formatAmount(list.principalAmount) }}</div>
                  <div>{{ formatAmount(list.interestAmount) }}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>

<!-- <div class="new-payment-form main-content">
  <div class="from-account-field">
    <label class="field-lbl">Loan accounts</label>
    <div class="loans-dropdown">
      <app-loans-dropdown [selectedAccount]="fromAccount" (onChange)="onChangeAccount($event)">
      </app-loans-dropdown>
    </div>
  </div>
  <div class="payment-entry-form">
    <label class="field-lbl" style="display: none;">To</label>
    <div class="warpper-card d-flex-row">
      <div *ngIf="showCalender" class="show-calender">
        <h4 class="calender--title">Plan my payment</h4>
        <div class="calender--input__container">
            <input class="input-field" type="text" id="datePicker" readonly />
            <i class="calender--input__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17.145" viewBox="0 0 19 17.145">
          <g id="_001-calendar" data-name="001-calendar" transform="translate(0 -25)">
            <path id="Path_9879" data-name="Path 9879"
              d="M19,30.344V28.154a1.672,1.672,0,0,0-1.67-1.67h-.223v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H11.17v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H5.232v2.041a.557.557,0,0,1-1.113,0V25.557a.557.557,0,0,0-1.113,0v.928H1.67A1.672,1.672,0,0,0,0,28.154v2.189Z"
              fill="#004A63" />

            <path id="Path_9880" data-name="Path 9880"
              d="M0,199v9.018a1.672,1.672,0,0,0,1.67,1.67H17.33a1.672,1.672,0,0,0,1.67-1.67V199Zm5.344,7.719H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm0-2.375H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm0-2.375H4.156a.557.557,0,0,1,0-1.113H5.344a.557.557,0,0,1,0,1.113Zm4.75,4.75H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H8.906a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm4.75,4.75H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Zm0-2.375H13.656a.557.557,0,0,1,0-1.113h1.188a.557.557,0,0,1,0,1.113Z"
              transform="translate(0 -167.543)" fill="#004A63" />
          </g>
        </svg>
      </i>
        </div>
        <div class="d-flex justify-between">
            <button class="btn-calendar">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="8.325" height="12.744" viewBox="0 0 8.325 12.744">
            <path id="Shape" d="M3.5,0,0,3.544,3.5,7.088" transform="translate(2 2.828)" fill="none" stroke="#000"
              stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4" opacity="0.1" />
          </svg>
        </i>
      </button>
            <span class="text-month">{{ displayMonth }}&nbsp; {{ displayYear }}</span>
            <button class="btn-calendar">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="8.325" height="12.745" viewBox="0 0 8.325 12.745">
            <path id="Shape" d="M0,0,3.5,3.544,0,7.088" transform="translate(2.828 2.828)" fill="none" stroke="#004A63"
              stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4" />
          </svg>
        </i>
      </button>
        </div>
        <div class="d-flex calendar-table" *ngIf="calendar">
            <div>Mon</div>
            <div>Tues</div>
            <div>Wed</div>
            <div>Thu</div>
            <div>Fri</div>
            <div>Sat</div>
            <div>Sun</div>
        </div>
        <ng-container *ngFor="let row of calendar | chunk: 7; let i = index">
            <div class="d-flex calendar-table">
                <div class="calendar-day" [ngClass]="{
            'past-date': currenctMonth != c.date.getMonth(),
            today: c.isToday
          }" *ngFor="let c of row; let j = index">
                    <div class="calendar-day-header" [ngClass]="{
              'select-date': installmentDates.includes(c.utcDate)
            }">
                        <span>{{ c.date.getDate() }}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        </div>
        <div class="list--repayment">
            <p class="list--title">
                Your instalments will be due on following dates :
            </p>
            <div class="d-flex table--repayment">
                <div>Due date</div>
                <div>Instalment</div>
                <div>Principal</div>
                <div>Interest</div>
            </div>
            <ng-container *ngFor="let list of repaymentScheduleDetails">
                <div class="d-flex table--repayment repayment-record">
                    <div>{{ list.dueDate | dateFormatter: "yyyy-mm-dd" }}</div>
                    <div>{{ formatAmount(list.installmentAmount) }}</div>
                    <div>{{ formatAmount(list.principalAmount) }}</div>
                    <div>{{ formatAmount(list.interestAmount) }}</div>
                </div>
            </ng-container>
        </div>
      </div>
  </div>
</div> -->
